import { mixins, styled, theme } from 'ui/theme';

export const Balance = {
  Container: styled.div`
    margin: ${theme.space[2]};
    padding: 0 ${theme.space[2]};
  `,

  Component: styled.div`
    width: 100%;

    div > h6 {
      margin: ${theme.space[2]} 0 ${theme.space[4]} 0;
    }
  `,

  Content: styled.div`
    ${mixins.baseFont};
    align-items: center;
    color: ${theme.colors.build.darkLight};
    display: flex;
    font-size: ${theme.fontSizes.md};
    justify-content: space-between;
    margin: ${theme.space[3]} ${theme.space[0]};
    min-width: 250px;
    width: 100%;

    &[data-spacing-top='none'] {
      margin-top: ${theme.space[0]};
    }

    &[data-spacing-bottom='none'] {
      margin-bottom: ${theme.space[0]};
    }

    &[data-spacing='none'] {
      margin: ${theme.space[0]};
    }
  `,

  Info: styled.span`
    align-items: center;
    display: flex;
    font-size: ${theme.fontSizes.md};
  `,

  Space: styled.div`
    margin-top: ${theme.space[2]};
  `,

  SubTotal: styled.span`
    ${mixins.baseFontHeading};
  `,

  TotalValue: styled.span`
    ${mixins.baseFontHeading};
    font-weight: ${theme.fontWeights.medium};
    font-size: ${theme.fontSizes.lg};
    color: ${theme.colors.build.brand1};
  `,
};
